import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle, useEffect } from 'react';
import { useTileLayer } from './useTileLayer';
export * from './useTileLayer';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    tileLayer,
    setVisiable
  } = useTileLayer(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    tileLayer
  }), [tileLayer]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setVisiable(props.visiable), [props.visiable]);
  return null;
});